import {DatePipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {CarrierService} from 'app/services/carrier.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {AuthWebService} from 'app/services/authweb.service';
import {CorspdcService} from 'app/services/corspdc.service';
import {UtilityServiceService} from 'app/services/utility-service.service';
import {CarriertransactionService} from 'app/services/carriertransaction.service';
import {ToastNotificationService} from 'app/shared/toast-notification/toast-notification.service';
import {NgbDate, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {CarrierAccountService} from '../../services/carrier-account.service';
// import * as jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import autoTable from 'jspdf-autotable';

var jsPDF = require('jspdf');
require('jspdf-autotable');

declare var printJS: any;

@Component({
  selector: 'app-statement',
  templateUrl: './statement.component.html',
  styleUrls: ['./statement.component.css']
})
export class StatementComponent implements OnInit {
  model: NgbDateStruct;
	date: { year: number; month: number };
  isLoading: boolean = false;
  isEmpty: boolean = false;
  listTransactions: any = [];
  user: any = {};
  page = 1
  dateTo;
  dateFrom;
  count: number = 0;
  currentPage = 1;
  pageSize: number = 10;
  debtoraccount: any = {};
  accountnumber:string;
  carrierid:string;
  message = "Submitting your request, please wait...";
  person_id: string;
  invoicedate:any;

  // @Output() transData = new EventEmitter();


  constructor(private carrierService: CarrierService, private authWebService: AuthWebService,private router:Router, public utility: UtilityServiceService, public transData: CarriertransactionService,
    private toaster:ToastrService,private toastService:ToastNotificationService,private carrierAccountService:CarrierAccountService,
    private datepipe:DatePipe, private route: ActivatedRoute, private crspdService:CorspdcService) {
    this.user = (this.authWebService.userData) ? this.authWebService.userData.User:null;
  }


  ngOnInit() {

    this.route.paramMap.subscribe(params => {
    this.accountnumber = params.get("id");
    this.utility.page = 1;
    this.utility.showstatementfooter = true;
    this.carrierid = params.get('carrierid');
    })
    this.getDebtorAccount(this.accountnumber);
    this.getCarrier();
    this.onReset();
    this.dateFrom = new NgbDate(new Date().getFullYear(), new Date().getMonth() - 2, new Date().getDate());
    this.dateTo = new NgbDate(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate());

  }

onChange = () => {

  // this.pageSize = 
  this.loadAccounts(this.accountnumber, new Date(this.dateFrom.year, this.dateFrom.month - 1, this.dateFrom.day,), new Date(this.dateTo.year, this.dateTo.month - 1, this.dateTo.day,));
}

  onReset = () => {

    let  date =new Date();

    this.dateTo =this.datepipe.transform(date, 'yyyy-MM-dd');
    var pastthreemonths = new Date(date.setDate(date.getDate()- 90));
    this.dateFrom =this.datepipe.transform(pastthreemonths, 'yyyy-MM-dd');
    this.loadAccounts(this.accountnumber,this.dateFrom,this.dateTo);
    this.dateFrom = new NgbDate(new Date().getFullYear(), new Date().getMonth() - 2, new Date().getDate());
    this.dateTo = new NgbDate(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate());
 
}

  loadAccounts = (custcode:string, datefrom: any, dateto:any ) => {
   
      this.isLoading = true;
      //console.log('user.ID = ', this.user.Id);
       this.carrierService.getlisttranscation(custcode, datefrom, dateto ).subscribe((result:any) => {
       this.listTransactions = result.Result;
       this.count = result.Count;
       this.isEmpty = (this.count == 0) ? true : false;
       //console.log(this.listTransactions);
      //  this.transData.statementlist = this.listTransactions;
       this.transData.changeList(this.listTransactions);
      
       this.transData.accountnumber = this.accountnumber;
       this.transData.screen = "statement";
       this.isLoading = false;

    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
      //console.log('Error occured: ' + error);

    })

 
  }

  GetInvoice(invnumber)
  {
    // this.router.navigate(['/carrier/invoice/', this.accountnumber, referencenumber]);
    this.router.navigate(['/carrier/invoice/' + this.accountnumber + '/' +invnumber + '/' +this.carrierid]);
  }

  getDebtorAccount(custcode:string)
  {

    this.carrierService.getDebtorAccount(custcode).subscribe((result:any) => {

      this.debtoraccount = result;
      this.count = result.Count;
      console.dir(this.debtoraccount);
      this.transData.debtoraccount = this.debtoraccount; 
      
   }, error => {
     console.error('Error occured: ' + error);
   })

  }

  onDateSelect(date: NgbDateStruct) {
    const selectedDate = new Date(date.year, date.month - 1, date.day); // month is zero-based
    return this.datepipe.transform(selectedDate, 'yyyy-MM-dd');
  }
  onSearch(){
    this.loadAccounts(this.accountnumber, this.onDateSelect(this.dateFrom), this.onDateSelect(this.dateTo));
  }

  getCarrier(){
      this.carrierService.carrierPersonByuserId(Number(this.user.Id)).subscribe((result:any) => {
      this.person_id = result.person_id;
      this.transData.personid = this.person_id;
      //console.log(result);
    }, error => {
      console.error(error);
    });
  }


  //generate PDF
  getStatementSSR(custcode:string, datefrom: NgbDate, dateto:NgbDate){

    var report = {
      CustomerCode: custcode,
      fromDate : this.onDateSelect(datefrom),
      toDate :this.onDateSelect(dateto),
    }
    this.carrierAccountService.downStatement(report).subscribe((x: Blob) => {
      const url = window.URL.createObjectURL(x);
      printJS({ printable: url, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });
      // obj.status_id = 75;
      this.isLoading = false;
    }, error => {
      console.log(error);
      this.isLoading = false;
      return this.toastService.error('An error occurred when trying to generate the statement, please try again or contact the system admin for help', 'error!')
    });

  }
  GenerateStatementPDF ()
  {

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'ZAR',
      minimumFractionDigits: 0
    });

    this.transData.currentlist.subscribe(data => this.listTransactions = data);
    this.debtoraccount = this.transData.debtoraccount;

    var doc = new jsPDF();
    var imgData = 'data:image/png;base64,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'
    // Add account details header
    var headercol= [" "," "];
    var headerrow = [];

    headerrow.push(["Account Id:", this.transData.debtoraccount.customer_code]);
    headerrow.push(["Account Name:", this.transData.debtoraccount.customer_name]);
    headerrow.push(["Contact Person:", this.transData.debtoraccount.contact_person]);
    headerrow.push(["Email:", this.transData.debtoraccount.email]);
    headerrow.push(["Statement Date:",  this.datepipe.transform(Date.now() , 'dd-MM-yyyy') ]);


    //transcation list table
    var col = ["Ref Number","Date", "Description", "Type", "Total"];
    var rows = [];

    this.listTransactions.forEach(element => {
      // var d = new Date(element.transaction_date);
      var temp = [element.reference_number, this.datepipe.transform(element.transaction_date, 'dd-MM-yyyy') ,element.transaction_description, element.transaction_type, formatter.format(element.transaction_total * -1)];
      rows.push(temp);
    });


    doc.setFontSize(14);
    doc.setTextColor(41,128,186);
    doc.text(15,20,'Statement');

    doc.autoTable(
        headercol,
        headerrow,
        { theme: 'plain',
          margin: { top:20, right:305 },
          styles:{ fontSize:10, overflow:'linebreak', columnWidth:'wrap' },
        });

    doc.autoTable(
        col,
        rows,
        {theme: 'striped',     margin: {top: 80}});

    doc.setFontSize(11);
    doc.text(120,doc.autoTable.previous.finalY + 10,'Account Balance: '+ formatter.format(this.transData.debtoraccount.AccountBalance * -1) , {});
    return doc;
  }

  emailStatement()
  {

    var report = {
      CustomerCode: this.accountnumber,
      fromDate : this.onDateSelect(this.dateFrom),
      toDate :this.onDateSelect(this.dateTo),
    }

    this.carrierAccountService.downStatement(report).subscribe((x: Blob) => {
     this.blobToBase64(x)
          .then((base64data) => {
            this.sendConfirmMail(base64data);
            console.log(base64data);
          })
          .catch((error) => {
            console.error(error);
          });
      this.ngOnInit();
    }, error => {
      console.log(error);
      return this.toastService.error('An error occurred when trying to print the permit, please try again or contact the system admin for help', 'error!')
    });


  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        const base64data = reader.result.toString().split(',')[1];
        resolve(base64data);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }


  sendConfirmMail(pdfDoc){
    let payload:any = new Object;
    payload.id= 0;
    payload.carrier_id=this.carrierid;
    payload.from_person_id= this.person_id;
    payload.app_id_permit_type_code= null;
    payload.carrierName= null;
    payload.person_from= this.person_id;
    payload.application_id=null;
    payload.permit_num= null;
    payload.document_id1=null;
    payload.document_id2=null;
    payload.document_id3=null;
    payload.corspdc_type_ind=1;
    payload.send_receive_ind=1;
    payload.comm_type_ind=1;
    payload.subject= 'ICBMS Statement';
    payload.body_text='';
    payload.note=null;
    payload.num_bookmarks=1;
    payload.bookmark1_value=null;
    payload.bookmark2_value=null;
    payload.bookmark3_value=null;
    payload.bookmark4_value=null;
    payload.bookmark5_value=null;
    payload.bookmark6_value=null;
    payload.date_to_send= new Date();
    payload.date_sent= new Date();
    payload.date_created=new Date();
    payload.date_modified=new Date();
    payload.user_created=new Date();
    payload.user_modified=new Date();
    payload.send_rcvd= null;
    payload.comm_type= null;
    payload.hasDoc= true;
    payload.attachment= pdfDoc;
    // payload.correspondence_person= ;
    payload.file_name='ICBMS Statement';
    //console.log(payload);
    this.crspdService.sendMail(payload).subscribe(res=>{
      console.log("Payload",payload);
      this.toastService.success(`Your statement was successfully emailed.`,'Success');
      this.isLoading = false;
    }, error => {
      console.log(error);
      this.toastService.error(`An error occured`,'Error');
      this.isLoading = false;
    })
  }

  downloadStatement()
  {
    this.isLoading = true;
    this.getStatementSSR(this.accountnumber, this.dateFrom, this.dateTo);

  }

  //Invoice Transactions

  GenerateInvoicePDF()
  {

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'ZAR',
      minimumFractionDigits: 0
    });

    this.debtoraccount = this.transData.debtoraccount;
    var doc = new jsPDF();


    var img = new Image()
    img.src = 'assets/crossboarderHeader1.png';

    doc.addImage(img, 'png', 5, 5, 190, 30);
    //Add account details header

    var headercol= [" "," "];
    var headerrow = [];

    ;


    //transcation list table
    var col = ["Item Code","Description", "Price Per Unit", "Quantity", "Total"];
    var rows = [];


    this.transData.invoicedetails.invoiceItems.forEach(element => {
      // var d = new Date(element.transaction_date);
      this.invoicedate =  this.datepipe.transform(this.transData.invoicedetails.InvoiceDate, 'dd-MM-yyyy');

      var temp = [element.ItemCode, element.Description, formatter.format(element.unit_price),  element.quantity, formatter.format(element.line_total)];
      rows.push(temp);
    });

    headerrow.push(["Account ID:", this.transData.debtoraccount.customer_code]);
    headerrow.push(["Account Name:", this.debtoraccount.customer_name]);
    headerrow.push(["Contact Person:", this.debtoraccount.contact_person]);
    headerrow.push(["Email:", this.debtoraccount.email]);
    headerrow.push(["Invoice Number:", this.transData.referencenumber]);
    headerrow.push(["Invoice Date:", this.invoicedate]);

    doc.setFontSize(14);
    doc.setTextColor(41,128,186);
    doc.text(15,40,'Invoice To');

    doc.autoTable(
        headercol,
        headerrow,
        { theme: 'plain',
          margin: { top:40, right:305 },
          styles:{ fontSize:10, overflow:'linebreak', columnWidth:'wrap' },
        });

    doc.autoTable(col, rows, {theme: 'striped', margin: {top: 90}});

    doc.setFontSize(11);
    doc.text(150, doc.autoTable.previous.finalY + 10, 'Invoice Total: '+ formatter.format(this.transData.invoicedetails.InclusiveTotal) );
    return doc;
  }

  printInvoice()
  {
    let doc = this.GenerateInvoicePDF();
    //console.log(doc.output('dataurlnewwindow'));
    window.open(
        doc,
        '_blank' // <- This is what makes it open in a new window.
    );
    // printJS({ printable: doc, type: 'pdf', showModal: true, modalMessage: 'Processing your request, please wait...' });
    // doc.output('dataurlnewwindow');

  }

  emailInvoice()
  {
    let doc = this.GenerateInvoicePDF();
    var pdfBase64 = doc.output('datauristring');


    let payload:any=Object();
    payload.carrier_id=this.transData.carrierid;
    payload.application_id=null;
    payload.document_id1=null;
    payload.document_id2=null;
    payload.document_id3=null;
    payload.corspdc_type_ind=1;
    payload.body_text=null;
    payload.notes=null;
    payload.attachment=pdfBase64;
    payload.subject='ICBMS Invoice';
    payload.send_receive_ind=1;
    payload.comm_type_ind=1;
    payload.num_bookmarks=1;
    payload.date_created=new Date();
    payload.date_modified=new Date();
    payload.user_created=new Date();
    payload.user_modified=new Date();
    payload.bookmark1_value=null;
    payload.bookmark2_value=null;
    payload.bookmark3_value=null;
    payload.bookmark4_value=null;
    payload.bookmark5_value=null;
    payload.bookmark6_value=null;
    payload.from_person_id= this.person_id;
    payload.correspondence_person= this.person_id;
    payload.file_name='ICBMS Invoice';

    this.crspdService.sendMail(payload).subscribe(res=>{
      //console.log(res);
      this.toastService.success(`Your invoice was successfully submitted successfully.`,'Success');
    }, error => {
      this.toastService.error(`An error occured`,'Error');
    });

  }

  cancelInvoice(){
    this.router.navigate(['carrier/statement/'+ this.transData.accountnumber + '/' + this.transData.carrierid]);
  }

  downloadInvoice()
  {
    let doc = this.GenerateInvoicePDF();
    doc.save(this.transData.referencenumber + '.pdf');

  }

  base64ToByteArray(base64: string): Uint8Array {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }
  onBack() {
    this.router.navigateByUrl('/carrier/accounts');
  }
  filterStatements() {
   
  this.loadAccounts(this.accountnumber, this.dateFrom, this.dateTo);
  }

}
